import { MinusSignSvg, PlusSignSvg } from 'Components/Svgs'

type AccordionCardProps = {
  id: number
  title: string
  activeAccordion: number
  setActiveAccordion: (id: number) => void
  children: React.ReactNode
  className?: string
  headerClassName?: string
  bodyClassName?: string
  error?: boolean
}

// Wrapper component to match design update. Takes in some props as seen
export const AccordionCard = ({
  id,
  title,
  activeAccordion,
  setActiveAccordion,
  children,
  className = '',
  headerClassName = '',
  bodyClassName = '',
  error = false,
  }: AccordionCardProps) => {
  const isActive = activeAccordion === id

  const handleToggle = () => {
    setActiveAccordion(isActive ? 0 : id)
  }

  return (
    <div
      className={`card ${className} ${
        error ? 'border border-danger shadow-lg' : 'border-0'
      } ${!isActive && 'pb-0'}`}
    >
      <div className={`card-header px-0 ${!isActive && 'border-bottom-0'} ${headerClassName}`}>
        <div className='row h-100'>
          <div className='col-6 col-md-6 my-auto'>{title}</div>

          <div className='col-6 text-end col-md-6 my-auto text-md-end'>
            <button className='btn p-0 border-0' type='button' onClick={handleToggle}>
              {isActive ? <MinusSignSvg /> : <PlusSignSvg />}
            </button>
          </div>
        </div>
      </div>

      {isActive && <div className={`card-body px-0 ${bodyClassName}`}>{children}</div>}
    </div>
  )
}
